<ol class="breadcrumb">
  <li class="breadcrumb-item"><a routerLink="/providers">Transport Companies</a></li>
  @if (provider.active) {
    <li class="breadcrumb-item"><a routerLink="/providers">Approved</a></li>
  }
  @if (!provider.active) {
    <li class="breadcrumb-item"><a routerLink="/providers-pending">Pending</a></li>
  }
  <li class="breadcrumb-item active">{{provider.name}}</li>
</ol>

<h1>{{provider.name}}</h1>

<ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link" routerLink="/providers/{{provider.id}}/">
      Details
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link active" routerLink="/providers/{{provider.id}}/users/">
      Users
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link"
      routerLink="/providers/{{provider.id}}/reports"
      routerLinkActive="active">
      Reports
    </a>
  </li>
</ul>

<div class="row">
  <div class="col-xs-12">
    @if (dispatchers && dispatchers?.length) {
      <p-table
        [value]="dispatchers"
        [totalRecords]="totalRecords"
        [paginator]="true"
        [rows]="rows"
        [first]="first"
        [showCurrentPageReport]="true"
        selectionMode="single"
        [(selection)]="selectedDispatcher"
        (onRowSelect)="onRowSelect($event)"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        stateStorage="session"
        stateKey="state-session-transportation-provider-users"
        >
        <ng-template pTemplate="header">
          <tr>
            @for (key of keys; track key) {
              <th pSortableColumn="{{ key }}">
                {{ tableConfig?.columns[key]?.title }} <p-sortIcon field="{{ key }}"></p-sortIcon>
              </th>
            }
          </tr>
          <tr>
            <th style="width:20%">
              <p-columnFilter
                type="text"
                field="last_name"
                [placeholder]="placeholders['last_name']"
                ariaLabel="Filter last name"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:20%">
              <p-columnFilter
                type="text"
                field="first_name"
                [placeholder]="placeholders['first_name']"
                ariaLabel="Filter first name"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:20%">
              <p-columnFilter
                type="text"
                field="email"
                [placeholder]="placeholders['email']"
                ariaLabel="Filter email"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:13%">
              <p-columnFilter
                type="text"
                field="confirmed_at"
                [placeholder]="placeholders['confirmed_at']"
                ariaLabel="Filter confirmed at"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:13%">
              <p-columnFilter
                type="text"
                field="active"
                [placeholder]="placeholders['active']"
                ariaLabel="Filter active"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:13%">
              <p-columnFilter
                type="text"
                field="created_at"
                [placeholder]="placeholders['created_at']"
                ariaLabel="Filter created at"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-activePlan>
          <tr [pSelectableRow]="activePlan">
            @for (key of keys; track key) {
              <td>{{ activePlan?.[key] }}</td>
            }
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</div>
